import { useMutation } from '@vue/apollo-composable';
import { flash, modal } from '@/helpers/ui';
import i18n from '@/i18n';
import { DELETE_PRODUCTS, RESTORE_PRODUCTS } from './graphql';

const { t } = i18n;

export const openConfirmationModal = (
  id: number,
  isDeleted: boolean,
  saving?: Ref<boolean>,
): Promise<void> => {
  const message = t(
    `global.confirmation.${isDeleted ? 'confirm_restore' : 'confirm_delete'}`,
    { item: t('global.items.product', 2) },
  );

  return modal('confirmation', {
    message,
    type: isDeleted ? '' : 'delete',
  }).then(() => {
    if (isDeleted) {
      return restoreProducts(id, saving);
    } else {
      return deleteProducts(id, saving);
    }
  });
};

const restoreProducts = (
  importId: number,
  saving?: Ref<boolean>,
): Promise<void> => {
  if (saving) saving.value = true;
  const { mutate } = useMutation(RESTORE_PRODUCTS);
  return mutate({
    input: {
      importId,
    },
  }).then((response) => {
    if (response?.data) {
      const productsCount =
        response.data.restoreImportedProducts.import.productsCount;
      flash(
        t('global.flash.item_restored', {
          item: `${productsCount} ${t('global.items.product', 2)}`,
        }),
      );
    }
  });
};

const deleteProducts = (
  importId: number,
  saving?: Ref<boolean>,
): Promise<void> => {
  if (saving) saving.value = true;
  const { mutate } = useMutation(DELETE_PRODUCTS);
  return mutate({
    input: {
      importId,
    },
  }).then((response) => {
    if (response?.data) {
      const productsCount =
        response.data.deleteImportedProducts.import.productsCount;
      flash(
        t('global.flash.item_deleted', {
          item: `${productsCount} ${t('global.items.product', 2)}`,
        }),
      );
    }
  });
};
